import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../hooks";
import {
  clearAllModelTypeAppliedFilters,
  doSearch,
  resetCurrentFilters,
  SEARCH_TYPES,
  setAppliedFilters,
  setModelTypeAppliedFilter,
  setSearchPeriod,
  setSelectedPersonFilter,
  uncheckFilter,
} from "../../../../store/reducer/_searchReducer";
import {
  getAppliedFilters,
  getCurrentModelTypeAppliedFilters,
  getCurrentSearchFilters,
  getCurrentSearchPeriod,
  getQueryValue,
  getSearchModelType,
  getSearchType,
  getSelectedPersonFilter,
} from "../../../../store/selectors";
import {
  buildDisplayedFilters,
  removeValueFromFilters,
} from "../../../../utils";
import { CarouselFilter } from "../_activeFilterTag";
import ActiveFilterTagCarousel from "../_activeFilterTagCarrousel";

const FilterCarouselContent = ({ tipo = "" }: { tipo: string }) => {
  const searchType = useSelector(getSearchType);

  const currentFilters = useSelector(getCurrentSearchFilters);
  const appliedFilters = useSelector(getAppliedFilters);
  const currentPeriod = useSelector(getCurrentSearchPeriod);

  const dispatch = useAppDispatch();

  const selectedPersonFilter = useSelector(getSelectedPersonFilter);
  const modalTypeAppliedFilters = useSelector(
    getCurrentModelTypeAppliedFilters,
  );
  const appliedModelType = useSelector(getSearchModelType);

  const personFilter = searchType.personFilter;

  const query = useSelector(getQueryValue);

  const currentSearchType = searchType.id;

  const handleClearAll = () => {
    dispatch(resetCurrentFilters());
    dispatch(setAppliedFilters({ appliedFilters: [] }));
    dispatch(clearAllModelTypeAppliedFilters());
    dispatch(
      setSearchPeriod({
        searchType: searchType.id,
        period: "always",
        startDate: null,
        endDate: null,
      }),
    );
    dispatch(
      setSelectedPersonFilter({
        searchType: searchType.id,
        value: "",
      }),
    );
    dispatch(
      doSearch({
        query,
        searchType: SEARCH_TYPES[tipo as keyof typeof SEARCH_TYPES],
        page: 1,
      }),
    );
  };

  function findIdByLabel(data: any, label: string) {
    for (const item of data) {
      if (item.label === label) {
        return item.id;
      }

      if (Array.isArray(item.options)) {
        const found: any = findIdByLabel(item.options, label);
        if (found) return found;
      }
    }

    return null;
  }

  const handleRemoveFilter = (filter: CarouselFilter) => {
    if (filter.type === "period") {
      dispatch(
        setSearchPeriod({
          searchType: searchType.id,
          period: "always",
          startDate: null,
          endDate: null,
        }),
      );
    } else if (filter.type === "person") {
      dispatch(
        setSelectedPersonFilter({
          searchType: searchType.id,
          value: "",
        }),
      );
    } else if (filter.type === "modelTypeFilter") {
      dispatch(
        setModelTypeAppliedFilter({
          modelType: appliedModelType,
          filters: modalTypeAppliedFilters.filter(
            (f: any) => f !== filter.label,
          ),
        }),
      );
    } else if (filter.type === "modelType") {
      dispatch(clearAllModelTypeAppliedFilters());
    } else {
      const filterId = findIdByLabel(currentFilters, filter.label);

      dispatch(uncheckFilter({ optionId: filterId }));

      const removedValueFromFilters = removeValueFromFilters(
        appliedFilters,
        filter.label,
      );

      dispatch(
        setAppliedFilters({
          appliedFilters: removedValueFromFilters,
        }),
      );
    }

    dispatch(
      doSearch({
        query,
        searchType: SEARCH_TYPES[tipo as keyof typeof SEARCH_TYPES],
        page: 1,
      }),
    );
  };

  return (
    <ActiveFilterTagCarousel
      filters={buildDisplayedFilters({
        appliedFilters,
        appliedModelType,
        currentPeriod,
        currentSearchType,
        modalTypeAppliedFilters,
        personFilter,
        selectedPersonFilter,
      })}
      onRemove={handleRemoveFilter}
      onClearAll={handleClearAll}
    />
  );
};

export default FilterCarouselContent;
